import {
  EventNames,
  EventParameters,
  FirebaseCommonEventNames,
  FirebaseEventParameters,
} from '@unu/ui-enums';

import {
  mapArguments,
} from './events';

export const parseFirebaseTagArgs = ({
  args,
  nameMap,
  context,
} = {}) =>{

  if (!Array.isArray(args)) {
    return {
      failureReason: 'Tag arguments must be an array',
    };
  }

  let name;
  let parameters = {};

  for (const arg of args) {

    if (!arg?.name) {
      continue;
    }

    const screen = arg.parameters?.[EventParameters.ScreenName];

    if (arg.name === EventNames.ScreenView && !screen) {

      return {
        failureReason: 'No screen name provided for Firebase screen view event.',
      };
    }

    if (arg.name === EventNames.ScreenView) {

      return {
        screenViewArgs: [
          {
            screen_class: screen,
            screen_name: screen,
          },
        ],
      };
    }

    const {
      mappedName,
      mappedParams,
    } = mapArguments({
      nameMap: nameMap ?? FirebaseCommonEventNames,
      parameterMap: FirebaseEventParameters,
      name: arg.name,
      parameters: arg.parameters,
      context,
    });

    name = mappedName;
    parameters = mappedParams;
    break;
  }

  if (!name || typeof name !== 'string') {

    return {
      failureReason: 'Valid Firebase tag event name not provided.',
    };
  }

  return {
    parsedArgs: [
      name,
      parameters,
    ],
  };
};

export const parseFirebaseTraceArgs = ({
  args,
  nameMap,
  context,
} = {}) => {

  if (!Array.isArray(args)) {
    return {
      failureReason: 'Trace arguments must be an array',
    };
  }

  const messages = [];
  let data = {};
  let error;

  for (const arg of args) {

    if (!arg) {
      continue
    }

    if (arg instanceof Error && !error) {

      error = arg;
      messages.push(arg.message);

      continue;
    }

    if (arg instanceof Error && error) {
      messages.push(arg.message);
      continue;
    }

    if(typeof arg === 'object') {

      data = {
        ...data,
        ...arg,
      };

      continue;
    }

    messages.push(String(arg));
  }

  const innerErrors = (messages.length > 0 && messages.join(' ')) || undefined;

  if (!innerErrors) {
    return {
      failureReason: 'Unable to find a valid error message',
    };
  }

  if (!error) {
    error = new Error(innerErrors);
  }

  const {
    mappedName,
    mappedParams,
  } = mapArguments({
    nameMap: nameMap ?? FirebaseCommonEventNames,
    parameterMap: FirebaseEventParameters,
    name: EventNames.Error,
    parameters: {
      ...data,
      [EventParameters.ErrorMessage]: innerErrors,
    },
    context,
  });

  if (!mappedName || typeof mappedName !== 'string') {

    return {
      failureReason: 'Valid Firebase trace event name not provided.',
    };
  }

  return {
    error,
    parsedArgs: [
      mappedName,
      mappedParams,
    ],
  };
}